<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead" style="text-indent: 0%;">Contents</h2>
<div class="contentsEntry" id="contentsEntry0">
<p class="contentsEntryName"><span href="#/9781429939973_bm01#bm01" title="Link target outside of Sample">Author’s Note</span></p></div>
<div class="contentsEntry" id="contentsEntry1">
<p class="contentsEntryName"><a href="#/9781429939973_ch01#ch01">1 A Dark and Bloody Ground</a></p></div>
<div class="contentsEntry" id="contentsEntry2">
<p class="contentsEntryName"><a href="#/9781429939973_ch02#ch02">2 Two Steps Back</a></p></div>
<div class="contentsEntry" id="contentsEntry3">
<p class="contentsEntryName"><a href="#/9781429939973_ch03#ch03">3 Home Sweet</a></p></div>
<div class="contentsEntry" id="contentsEntry4">
<p class="contentsEntryName"><span href="#/9781429939973_ch04#ch04" title="Link target outside of Sample">4 ABC</span></p></div>
<div class="contentsEntry" id="contentsEntry5">
<p class="contentsEntryName"><span href="#/9781429939973_ch05#ch05" title="Link target outside of Sample">5 Down by the River</span></p></div>
<div class="contentsEntry" id="contentsEntry6">
<p class="contentsEntryName"><span href="#/9781429939973_ch06#ch06" title="Link target outside of Sample">6 The Displaced</span></p></div>
<div class="contentsEntry" id="contentsEntry7">
<p class="contentsEntryName"><span href="#/9781429939973_ch07#ch07" title="Link target outside of Sample">7 Rising Again</span></p></div>
<div class="contentsEntry" id="contentsEntry8">
<p class="contentsEntryName"><span href="#/9781429939973_ch08#ch08" title="Link target outside of Sample">8 The Midnight Run</span></p></div>
<div class="contentsEntry" id="contentsEntry9">
<p class="contentsEntryName"><span href="#/9781429939973_ch09#ch09" title="Link target outside of Sample">9 Brother Against…</span></p></div>
<div class="contentsEntry" id="contentsEntry10">
<p class="contentsEntryName"><span href="#/9781429939973_ch10#ch10" title="Link target outside of Sample">10 What Whispers</span></p></div>
<div class="contentsEntry" id="contentsEntry11">
<p class="contentsEntryName"><span href="#/9781429939973_ch11#ch11" title="Link target outside of Sample">11 Digging for More</span></p></div>
<div class="contentsEntry" id="contentsEntry12">
<p class="contentsEntryName"><span href="#/9781429939973_ch12#ch12" title="Link target outside of Sample">12 Visiting Unannounced</span></p></div>
<div class="contentsEntry" id="contentsEntry13">
<p class="contentsEntryName"><span href="#/9781429939973_ch13#ch13" title="Link target outside of Sample">13 Back to the Battlefield</span></p></div>
<div class="contentsEntry" id="contentsEntry14">
<p class="contentsEntryName"><span href="#/9781429939973_ch14#ch14" title="Link target outside of Sample">14 Aftermath</span></p></div>
<div class="contentsEntry" id="contentsEntry15">
<p class="contentsEntryName"><span href="#/9781429939973_ch15#ch15" title="Link target outside of Sample">15 Fresh Resolve</span></p></div>
<div class="contentsEntry" id="contentsEntry16">
<p class="contentsEntryName"><span href="#/9781429939973_ch16#ch16" title="Link target outside of Sample">16 The Recovery</span></p></div>
<div class="contentsEntry" id="contentsEntry17">
<p class="contentsEntryName"><span href="#/9781429939973_ch17#ch17" title="Link target outside of Sample">17 Invited</span></p></div>
<div class="contentsEntry" id="contentsEntry18">
<p class="contentsEntryName"><span href="#/9781429939973_ch18#ch18" title="Link target outside of Sample">18 Winding Down</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429939973_con01.vue?590d60c6